import { AppService } from './../core/app.service';
import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { TypeCompteReq } from "../data/http/requests/typecompte.req";
import { TypeCompteRes } from "../data/http/responses/typecompte.res";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class TypeCompteService extends AbstractService<TypeCompteReq, TypeCompteRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}type-compte`, http, AppService); 
    }
}